import { User } from 'oidc-client-ts'
import { type LoaderFunction, redirect } from 'react-router'
import { AuthenticationError } from '#features/User/AuthenticationError'
import { injectSession } from '#features/User/userManager'

export interface InjectTokenLoaderData {
  error?: unknown
}

export const injectTokenLoader: LoaderFunction = async ({ request }) => {
  const searchParams = new URL(request.url).searchParams
  const to = searchParams.get('to') ?? '/'

  // try if it contains an access_token already
  if (searchParams.has('access_token')) {
    await injectSession(
      new User({
        token_type: 'Bearer',
        access_token: searchParams.get('access_token') ?? '',
        id_token: searchParams.get('id_token') ?? '',
        refresh_token: searchParams.get('refresh_token') ?? '',
        expires_at: Number.MAX_SAFE_INTEGER,
        scope: 'openid profile email',
        profile: {
          sub: '',
          iss: '',
          aud: '',
          exp: 0,
          iat: 0,
          name: 'Technical User',
        },
      }),
    )

    // wait for the session to be injected?!
    await new Promise((resolve) => {
      setTimeout(() => {
        resolve(null)
      }, 100)
    })

    return redirect(to)
  }

  return {
    error: new AuthenticationError('No access token found in URL'),
  }
}
